__turbopack_context__.v({
  "suggestion": "lA0C_q_suggestion",
  "title": "lA0C_q_title",
  "wrapper": "lA0C_q_wrapper",
});
